import { AppLinkComponent } from "@sellernote/shared/src/api/dto/entities/common/common";

import Styled from "./index.styles";

export default function BoardListItem({
  title,
  date,
  writer,
  href,
  LinkComponent,
  className,
}: {
  title: string;
  date: string;
  writer: string;
  href: string;
  LinkComponent: AppLinkComponent;
  className?: string;
}) {
  return (
    <Styled.container
      className={`${className ? className : ""} board-list-item`}
    >
      {/* next/link 의 경우 */}
      {typeof LinkComponent === "function" &&
        LinkComponent({
          href,
          children: (
            <a>
              <h4>{title}</h4>

              <div className="board-contents-info">
                <em className="date">{date}</em>
                <strong className="writer">{writer}</strong>
              </div>
            </a>
          ),
        })}

      {/* react-router-dom link 의 경우 */}
      {typeof LinkComponent! !== "function" &&
        (LinkComponent as any).render({
          to: href,
          children: (
            <>
              <h4>{title}</h4>

              <div className="board-contents-info">
                <em className="date">{date}</em>
                <strong className="writer">{writer}</strong>
              </div>
            </>
          ),
        })}
    </Styled.container>
  );
}
